module.exports = "label {\n  font-size: 15px; }\n\n.foto {\n  display: block;\n  margin-left: auto;\n  margin-right: auto; }\n\n.card {\n  width: 65%; }\n\n.mask {\n  padding: 50px; }\n\n@media (max-width: 575.98px) {\n  .mask {\n    padding: 10px; }\n  .card {\n    width: 100%; }\n  .enviar {\n    font-size: 10px; } }\n\n@media (min-width: 576px) and (max-width: 767.98px) {\n  .mask {\n    padding: 10px; }\n  .card {\n    width: 100%; }\n  .enviar {\n    font-size: 10px; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/componentes/register-page/register-page.component.scss
// module id = ./src/app/componentes/register-page/register-page.component.scss
// module chunks = main